import { Injectable } from '@angular/core';
import { AuthStore } from '@store';
import { EventsHistoryApi } from '@vi-iot/client';
import { BaseApiPickerImpl } from '@vi-iot/client/apis/base.api-picker';
import { EventsHistoryMockApi } from '@vi-iot/client/apis/events-history/events-history.mock.api';

@Injectable({ providedIn: 'root' })
export class EventsHistoryApiPicker extends BaseApiPickerImpl<
  EventsHistoryApi | EventsHistoryMockApi
> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: EventsHistoryApi,
    protected mockApi: EventsHistoryMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
